<script>
import { clearMobileNotificationHistory, unregisterMobileDevice } from "@/mobile/service";
import authService from "../service";
import { clearSupportSession, getSupportSession } from "../supportSession";

export default {
  name: "authentication-logout",
  render() {
    return false
  },
  async created() {
    const supportSession = getSupportSession();
    try {
      if (supportSession) await authService.endSupportAccess();
      else await unregisterMobileDevice();
    } catch (error) {
      // Local sign-out and privacy cleanup must continue if the device is offline.
    } finally {
      if (supportSession) {
        clearSupportSession();
        this.$router.replace("/support-ended");
      } else {
        clearMobileNotificationHistory();
        localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`)
        localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationId`)
        this.$router.replace("/login")
      }
    }
  },
}
</script>
